export const summeryStyle = props => ({
  marginTop: props.summaryShowHide ? "0" : "-250px",
  transition: "all 1s ease-in-out",
});



// WEBPACK FOOTER //
// ./src/style/components/Summary/commonSummary.jsx